import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuItem, ListItemIcon, Typography } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useAuth } from '../context/AuthContext';

interface LogoutButtonProps {
  onClick?: () => void;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ onClick }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    if (onClick) onClick();
    navigate('/login');
  };

  return (
    <MenuItem onClick={handleLogout}>
      <ListItemIcon>
        <ExitToAppIcon fontSize="small" color="error" />
      </ListItemIcon>
      <Typography>Logout</Typography>
    </MenuItem>
  );
};

export default LogoutButton;